export function downloadPdf(filename, elementId) {
    const html2pdf = require('html2pdf.js');

    const element = document.getElementById(elementId);

    html2pdf().from(element).set({
        image: { type: 'jpeg', quality: 0.5 },
        html2canvas: {
            dpi: 256,
            scale: 2,
            useCORS: true
        },
        jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait', compress: true },
        margin: [0, 0, 0, 0],
    }).toPdf().save(filename);
}

export function generateBase64Pdf(elementId) {
    const html2pdf = require('html2pdf.js');

    const element = document.getElementById(elementId);
    return new Promise((resolve, reject) => {
        html2pdf().from(element).set({
            image: { type: 'jpeg', quality: 0.5 },
            html2canvas: {
                dpi: 256,
                scale: 2,
                useCORS: true
            },
            jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait', compress: true },
            margin: [0, 0, 0, 0],
        }).outputPdf().then(function (pdf) {
            // This logs the right base64
            resolve(btoa(pdf));
        });
    });
}